

import {Component, Prop} from "vue-property-decorator";
import {UserLevel} from "shared/entities/user";
import * as icons from "@fortawesome/free-solid-svg-icons";
import {orderBy} from "lodash";
import AuthMixin from "@/mixins/auth.mixin";
import {Api} from "shared/api";
import {apiHandler} from "@/services/api-handler";
import {IImportantLink} from "shared/entities/important-link";

@Component({})
export default class ImportantLinksSection extends AuthMixin {
    @Prop({default: false})
    v2!: boolean;

    UserLevel = UserLevel;
    icons = icons;
    importantLinks: IImportantLink[] = [];

    get orderedImportantLinks(): IImportantLink[] {
        return orderBy(this.importantLinks, ["order"]);
    }

    async mounted() {
        this.importantLinks = await apiHandler(() => Api.importantLink.Get());
    }
}

